// material-ui
import { alpha } from '@mui/material/styles';

// project imports
import { getVisualDepth } from '../visualDepth';

// ==============================|| OVERRIDES - DIALOG ||============================== //
// Modal container (paper): stronger edge, panel look. Applied app-wide.
// No bottom border on last content section (footer already has borderTop).

export default function Dialog(theme) {
  const vd = getVisualDepth(theme);

  return {
    MuiDialog: {
      // Esc-to-close is blocked app-wide in themes/DialogEscapeGuard.jsx (MUI 9 dropped disableEscapeKeyDown).
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: alpha('#000', vd.dialogBackdropAlpha)
          },
          '& .MuiDialogContent-root > *:last-child': {
            borderBottom: 'none'
          },
          '& .MuiTab-root': {
            paddingTop: 0
          }
        },
        paper: {
          backgroundImage: 'none',
          border: vd.dialogPaperBorder,
          boxShadow: vd.dialogPaperShadow,
          borderRadius: 8,
          background: vd.dialogPaperBackground,
          borderLeft: vd.dialogLeftAccent
        }
      }
    }
  };
}
